<template>
    <div>
        <h3 v-if="isFail" class="fail">
            {{ 'shopcart.error_message' | trans }}
        </h3>
        <articles :articles="articles" :editable="false" @update="updateArticles" />
        <div class="booking-info">
            <h3>{{ 'shopcart.check_data' | trans }}</h3>
            <div class="payment">
                <i v-if="!isNil(data.payment.icon)" :class="data.payment.icon" />
                <img v-else :src="data.payment.image" />
                <aside>
                    <h4>{{ data.payment.title | trans }}</h4>
                    <p>{{ data.payment.description | trans }}</p>
                </aside>
            </div>
            <div class="data">
                <ul>
                    <li v-for="(value, index) in clientData()" :key="index">
                        <p>
                            <strong>{{ `shopcart.${index}` | trans }}:</strong>
                            <span class="wordwarp">{{ value }}</span>
                        </p>
                    </li>
                </ul>
                <div v-for="{ id, title, attributes } in articles" :key="id">
                    <h4>
                        <template v-if="!isTransfer(id)">
                            {{ title }}
                        </template>
                        <template v-else>
                            {{ `transfer.${title}` | trans }}
                        </template>
                    </h4>
                    <ul>
                        <template v-for="(value, index) in attributes">
                            <li
                                v-if="
                                    index !== 'image' &&
                                        index !== 'icon' &&
                                        index !== 'meeting' &&
                                        index !== 'destination'
                                "
                                :key="index"
                            >
                                <p>
                                    <strong>{{ `shopcart.product_${index}` | trans }}:</strong>
                                    <template v-if="index !== 'extras'">
                                        <span class="wordwarp" :key="extra">
                                            {{ value }}
                                        </span>
                                    </template>
                                    <template v-else v-for="{ extra, label, value: ex_value } in value">
                                        <span class="wordwarp" :key="extra">
                                            <b>{{ label }}:</b> {{ ex_value }} &euro;
                                        </span>
                                    </template>
                                </p>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
        <template v-if="articles.length > 0">
            <paypal v-if="data.payment.type === 'paypal'" :items="articles" />
            <cash v-else-if="data.payment.type === 'cash'" />
            <redsys v-else-if="data.payment.type === 'tpv'" :items="articles" />
        </template>
    </div>
</template>

<script>
import { isNil, hasIn } from 'ramda';

import Articles from '../components/Articles';
import Paypal from '../components/Paypal';
import Cash from '../components/Cash';
import Redsys from '../components/Redsys';

const api = window.groovie.api;
const baseUrl = api.base;

let cart = baseUrl;
if (hasIn('list', api) && !isNil(api.list)) {
    cart = `${cart}/${api.list}`;
}

export default {
    name: 'check',
    props: {
        data: {
            type: Object,
            default: () => ({
                name: '',
                lastName: '',
                phone: '',
                email: '',
                address: '',
                city: '',
                country: '',
                postal: '',
                observations: '',
                payment: ''
            })
        }
    },
    data() {
        return {
            articles: []
        };
    },
    computed: {
        isFail() {
            return this.$route.name === 'fail';
        }
    },
    methods: {
        isTransfer(value) {
            return value.indexOf('transfer') >= 0;
        },
        get() {
            this.$groovie
                .get(cart)
                .then(({ data }) => {
                    this.articles = data.map(({ id, name, price, quantity, attributes }) => {
                        const { image, icon } = attributes;

                        const article = {
                            id,
                            title: name,
                            image,
                            icon,
                            price,
                            quantity,
                            attributes
                        };
                        return article;
                    });
                })
                .catch(data => console.error('fail get', data));
        },
        isNil(value) {
            return isNil(value);
        },
        clientData() {
            return {
                full_name: `${this.data.name} ${this.data.lastName}`,
                phone: this.data.phone,
                email: this.data.email,
                address: this.data.address,
                city: this.data.city,
                country: this.data.country,
                postal: this.data.postal,
                observations: this.data.observations
            };
        }
    },
    beforeMount() {
        this.get();
    },
    components: {
        Articles,
        Paypal,
        Cash,
        Redsys
    }
};
</script>



// WEBPACK FOOTER //
// src/sections/Check.vue